import React, { Fragment, useCallback, useEffect, useRef } from "react";
import { Col, Container, Row } from "reactstrap";
import LoginForm from "./LoginForm";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { USER_TYPES } from "../../Constant";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "universal-cookie"; // Import Cookies as default

/** Get a query parameter from the current page URL */
function getQueryParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

const POPUP_WIDTH = 420;
const POPUP_HEIGHT = 560;

const Login = () => {
  const { type, id } = useParams();
  const cookies = new Cookies();
  const navigate = useNavigate();
  /** Ref to the SSO popup window so we can close it before opening a new one */
  const centralWindowRef = useRef(null);
  const isValidLoginType = USER_TYPES.find(
    (loginType) => loginType === type?.toUpperCase()
  );
  console.log("isValidLoginType7", isValidLoginType);
  console.log('type', type);
  /** Keep ?redirect= for SSO / central_callback (cross-step). */
  useEffect(() => {
    const r = getQueryParam("redirect");
    if (r) {
      try {
        sessionStorage.setItem("naukrify_post_login_redirect", r);
      } catch (e) {}
    }
  }, []);

  useEffect(() => {
    if (type?.toUpperCase() === 'JOBSEEKER') {
      const token = localStorage.getItem('_token');
      console.log("token2", token);
      if (!token) {
        const central_url = 'https://zoblik.com/sso/';

        (async () => {
          try {
            const response = await fetch(central_url + 'check_login.php', {
              credentials: 'include',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              }
            });
            console.log('response:', response);
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            console.log('data:', data);

            if (data.status && data.token) {
              document.cookie = `zoblik_central_token=${data.token}; path=/;`;
              let cb = "/job/central_callback?token=" + encodeURIComponent(data.token);
              try {
                const red = sessionStorage.getItem("naukrify_post_login_redirect");
                if (red) cb += "&redirect=" + encodeURIComponent(red);
              } catch (e) {}
              window.location.href = cb;
            }

          } catch (error) {
            console.error('Error during login check:', error);
          }

          console.log('Fetch completed, executing next code...');
        })();
        // navigate('central_callback?token=' + token);
      }
    }
  }, [type]);

  /**
   * Opens the Google/SSO login popup centered on the screen.
   * Reads login URL from #googleLoginBtn data-login-url and appends logo + email params.
   * Closes any existing popup before opening a new one.
   */
  const openCentralLogin = useCallback(() => {
    const btn = document.getElementById("googleLoginBtn");
    if (!btn) return;

    if (centralWindowRef.current && !centralWindowRef.current.closed) {
      centralWindowRef.current.close();
    }

    const logoEl = document.getElementById("img_logo");
    const logoUrl = logoEl ? logoEl.src || "" : "";
    let url = btn.getAttribute("data-login-url") || "";
    if (logoUrl) {
      url += (url.indexOf("?") >= 0 ? "&" : "?") + "logo=" + encodeURIComponent(logoUrl);
    }
    const email = getQueryParam("email");
    if (email) {
      url += (url.indexOf("?") >= 0 ? "&" : "?") + "email=" + encodeURIComponent(email);
    }

    const screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const screenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const screenWidth = window.innerWidth || document.documentElement.clientWidth;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight;
    const left = screenLeft + (screenWidth - POPUP_WIDTH) / 2;
    const top = screenTop + (screenHeight - POPUP_HEIGHT) / 2;

    centralWindowRef.current = window.open(
      url,
      "centralSSO",
      `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,status=no`
    );
    if (centralWindowRef.current) {
      centralWindowRef.current.focus();
    }
  }, []);

  /**
   * Listen for SSO_SUCCESS postMessage from popup.
   * Redirect to central_callback?token=... (same as indiagethired.com/job/central_callback?token=...)
   * so CentralCallback handles the token and sends the user to the jobseeker dashboard.
   */
  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.data || event.data.type !== "SSO_SUCCESS") return;
      const { token } = event.data;
      if (!token) return;
      const base = process.env.PUBLIC_URL || "/job";
      let callbackUrl = `${window.location.origin}${base}/central_callback?token=${encodeURIComponent(token)}`;
      try {
        const red = sessionStorage.getItem("naukrify_post_login_redirect");
        if (red) {
          callbackUrl += `&redirect=${encodeURIComponent(red)}`;
        }
      } catch (e) {}
      window.location.href = callbackUrl;
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  /** Auto-open popup when page URL contains email query param */
  useEffect(() => {
    if (!getQueryParam("email")) return;
    const t = setTimeout(openCentralLogin, 100);
    return () => clearTimeout(t);
  }, [openCentralLogin]);

  // useEffect(() => {
  //   if (!isValidLoginType) {
  //     navigate("/404");
  //   }
  // }, []);

  const getDomain = () => {
    const hostname = window.location.hostname;
    if (hostname === "localhost") {
      return "localhost"; // for local development
    } else if (hostname.endsWith("naukrify.com")) {
      return ".naukrify.com"; // for naukrify.com subdomains
    }
    return hostname;
  };

  useEffect(() => {
    if (id) {
      if (!isValidLoginType) {
        navigate("/404");
      } else {
        cookies.set("ref_code", id, {
          path: "/",
          domain: getDomain(),
          sameSite: "None",
          secure: true,
        });
        cookies.set("ref_type", type, {
          path: "/",
          domain: getDomain(),
          sameSite: "None",
          secure: true,
        });
      }
    }
  }, [id, type, isValidLoginType, navigate, cookies]);

  return (
    <Fragment>
      <section>
        <Container fluid={true}>
          <Row>
            <Col
              xl="5"
              className="b-center bg-size"
              style={{
                backgroundImage: `url(${require("../../assets/images/login/office.jpg")})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "block",
              }}
            >
              {/* <img className='bg-img-cover bg-center d-none' src={require('../../assets/images/login/office.jpg')} alt='looginpage' /> */}
            </Col>
            <Col xl="7 p-0">
              <LoginForm logoClassMain="text-start" onOpenCentralLogin={openCentralLogin} />
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </section>

    </Fragment>
  );
};

export default Login;
